import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IAzureSearchFacet } from "@/shared/services/azure-search-service";
import { IFilterItem } from "../models/filter-item-model";
import IFilterGroup from "../models/filter-group-model";
import { IFilterService } from "./interfaces/filter-service-interface";

export abstract class BaseFilterService implements IFilterService {
    public userFilters!: IFilterGroup[]
    public labels!: IDictionary<string>
    public searchFilters!: IDictionary<IAzureSearchFacet[]>

    constructor(userFilters: IFilterGroup[] = [], labels: IDictionary<string> = {}) {
        this.userFilters = userFilters
        this.labels = labels
    }

    public abstract initialize(): IFilterGroup[]

    public disable(filterGroup: IFilterGroup, filterItem: IFilterItem, activeFilterGroup: string): boolean {
        if (filterItem.FilterGroup === activeFilterGroup && !filterItem.Disabled) {
            return false
        }

        return this.shouldDisable(filterGroup, filterItem)
    }

    public abstract shouldDisable(filterGroup: IFilterGroup, filterItem: IFilterItem): boolean
}

